import { GET_PRODUCTS_BY } from "@/Apollo/Queries";
import productBySlugQuery from "@/Apollo/query/productBySlug.graphql";
import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { useQuery } from "@apollo/client";

const useProductsBy = ({ variables }) => {
  return useQuery(GET_PRODUCTS_BY, {
    variables,
  });
};

/**
 * The product page's product. The server renders it in each listing's own currency; with a
 * display currency (WHO-5142) the browser asks again in it, as the apps do.
 */
export const useProductsBySlug = ({ variables, onError, fetchPolicy }) => {
  const currency = useDisplayCurrency();

  return useQuery(
    productBySlugQuery,
    withDisplayCurrency({ variables, onError, fetchPolicy }, currency)
  );
};

export default useProductsBy;
